import { Action } from '@ngrx/store';

import { IdentityClaims } from '../../../login/models/identity-claims.model';

export const LOGIN_SUCCESSFUL = '[LOGIN] LOGIN_SUCCESSFUL';
export const LOGIN_FAILED = '[LOGIN] LOGIN_FAILED';

export class LoginSuccessful implements Action {
	readonly type = LOGIN_SUCCESSFUL;

	public constructor(public payload: IdentityClaims) {}
}

export class LoginFailed implements Action {
	readonly type = LOGIN_FAILED;
}

export type All
	= LoginSuccessful
	| LoginFailed;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/actions/login.ts